import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Signature } from "@phosphor-icons/react";

export default function SignupStep3Sign({
  tierInfo, waitingList, selectedSlots,
  form, setForm,
  signature, setSignature,
  submitting, isUpdating,
  onBack, onSubmit,
}) {
  return (
    <>
      <div className="rounded-2xl bg-cvc-parchment/60 border border-cvc-border p-5">
        <p className="text-xs tracking-[0.2em] uppercase font-body font-semibold text-cvc-red">Review</p>
        <h3 className="font-heading text-2xl text-cvc-navy mt-1">{tierInfo?.name}</h3>
        <p className="font-body text-sm text-cvc-ink-soft">${tierInfo?.monthly_total?.toLocaleString()}/mo · {tierInfo?.meetings_per_month} meetings / month · 24-month initial term</p>
        <p className="font-body text-sm text-cvc-ink-soft mt-1">First-month + last-month retainer due before services begin: <span className="text-cvc-ink font-medium">${tierInfo?.first_last_retainer?.toLocaleString()}</span></p>
        <div className="mt-3 text-sm font-body text-cvc-ink">
          <span className="text-cvc-ink-soft">Preferred windows:</span>{" "}
          {waitingList ? "Soonest-next-availability waiting list" : selectedSlots.length === 0 ? "None selected" : selectedSlots.join(", ")}
        </div>
      </div>

      {/* Contact details — moved here so prospects only surrender email/phone/address after
          they've engaged with slots + tier + terms. Improves conversion + reads as low-commitment
          up front. */}
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">Your Title</Label>
          <Input data-testid="signup-owner-title" placeholder="Owner / Manager / Partner" value={form.owner_title} onChange={(e) => setForm({ ...form, owner_title: e.target.value })} className="mt-1.5 bg-white border-cvc-border" />
        </div>
        <div>
          <Label className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">Email *</Label>
          <Input data-testid="signup-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 bg-white border-cvc-border" />
        </div>
        <div>
          <Label className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">Mobile *</Label>
          <Input data-testid="signup-phone" type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1.5 bg-white border-cvc-border" />
        </div>
        <div>
          <Label className="font-body text-xs uppercase tracking-wider text-cvc-ink-soft">Street Address *</Label>
          <Input data-testid="signup-street-address" placeholder="123 Main St, Logan UT 84321" value={form.street_address} onChange={(e) => setForm({ ...form, street_address: e.target.value })} className="mt-1.5 bg-white border-cvc-border" />
        </div>
      </div>

      <div className="rounded-2xl border-2 border-cvc-navy bg-white p-5">
        <div className="flex items-center gap-2">
          <Signature size={20} weight="duotone" className="text-cvc-navy" />
          <h4 className="font-heading text-xl text-cvc-navy">Digital Signature</h4>
        </div>
        <p className="font-body text-xs text-cvc-ink-soft mt-1">
          Type your full name. This serves as your binding electronic signature on the Engagement Letter above.
        </p>
        <Input
          data-testid="signup-signature"
          value={signature}
          onChange={(e) => setSignature(e.target.value)}
          placeholder="Your full legal name"
          className="mt-3 bg-cvc-cream border-cvc-border font-heading text-2xl italic h-14"
        />
        <p className="font-body text-[10px] text-cvc-ink-soft mt-2">
          Signed on {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>
      </div>

      <div className="flex items-center justify-between gap-4 flex-wrap">
        <Button variant="ghost" data-testid="signup-step3-back" onClick={onBack} className="text-cvc-ink-soft">← Back</Button>
        <div className="flex items-center gap-4 flex-wrap ml-auto">
          <p className="font-body text-xs text-cvc-ink-soft italic">Jonathan may require meeting before accepting your case. Payment is not processed until you're accepted as a client.</p>
          <Button
            data-testid="signup-submit"
            disabled={submitting}
            onClick={onSubmit}
            className="bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full px-10 py-5 h-auto"
          >
            {submitting ? "Submitting…" : (isUpdating ? "Update signup request" : "Submit signup request")}
          </Button>
        </div>
      </div>
    </>
  );
}
